import TMain from '../templates/main';
import useSection from '@shared/components/utils/hooks/useSection';
import { QuerySections } from '@shared/types/enums/sections';

/**
 * Series page component that displays series content with highlights and reels.
 * Starts navigation in menu position.
 */
export default function Series() {
  const { complete, highlights, reels, onPagination } = useSection({
    section: QuerySections.SERIES,
  });

  return (
    <TMain
      complete={complete}
      rails={reels}
      hideBackground={true}
      sliders={highlights}
      startsInMenu
      onPagination={onPagination}
    />
  );
}
